import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../store/ApplicationState";
import { getUserModule } from "../../actions/Modules";
import { ModulesDispatchTypes } from "../../models/DispatchTypes/Modules";
import Menus from "../components/Menus";
import { getUserPermissionCall } from "../../actions/User";
import { withErrorBoundary } from "../../components/custom/structure/components/ErrorBoundary";
import ErrorFallback from "../../components/custom/structure/components/ErrorFallback";

const mapStateToProps = ({
  userModuleState,
  loggedInUserState,
  userDetailsState,
}: ApplicationState) => ({
  item: userModuleState,
  user: loggedInUserState.response ,
  userDetails: userDetailsState.response 
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    ModulesDispatchTypes>
) => {
  return {
    getUserModules: (userId: number) => {
      dispatch(getUserModule(userId));
    },
    getUserPermission: (userId: number) => {
      dispatch(getUserPermissionCall(userId));
    },
  };
};

const ConnectedMenus = connect(mapStateToProps, mapDispatchToProps)(Menus);

ConnectedMenus.displayName = "Menus";

export default withErrorBoundary(ConnectedMenus, {
  fallback: ErrorFallback,
});
